import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import {
  setData,
  stepAddMessage,
  stepDeleteMessage,
  stepDownMessage,
  stepUpMessage,
} from '../../../features/ecBindingSlice';
import Messages from '../../shared/Messages';
import Preview from '../../shared/MessagesPreview';
import FailTag from './FailTag';
import Header from './Header';

const useStyles = makeStyles(
  {
    root: {
      display: 'flex',
    },
    setting: {
      width: 'calc(100% - 360px + 44px)',
    },
  },
  {
    name: 'Step4Container',
  },
);

const Step4Container = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { data, isSaved } = useSelector(store => store.ecBinding);
  const { bindResult } = data || {};
  const { fail } = bindResult || {};
  const { tag: failTag, messages: failMessages } = fail || {};

  const handleFailTagChange = value => {
    dispatch(
      setData({
        bindResult: {
          ...bindResult,
          fail: {
            ...fail,
            tag: value,
          },
        },
      }),
    );
  };

  const handleMessagesChange = value => {
    dispatch(
      setData({
        bindResult: {
          ...bindResult,
          fail: {
            ...fail,
            ...value,
          },
        },
      }),
    );
  };

  return (
    <div className={classes.root}>
      <div className={classes.setting}>
        <Header />
        <Messages
          addMessage={stepAddMessage}
          deleteMessage={stepDeleteMessage}
          upMessage={stepUpMessage}
          downMessage={stepDownMessage}
          isSaved={isSaved}
          messages={failMessages}
          onChange={handleMessagesChange}
          platform="ig"
          dataKey="fail"
        />
        <FailTag failTag={failTag} onFailTagChange={handleFailTagChange} />
      </div>
      <Preview messages={failMessages} />
    </div>
  );
};

export default Step4Container;
